if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.overlay = document?.querySelector('.js-modal-overlay') || null;

        // Close modal on overlay click
        if (this.overlay && !this.overlay.dataset.hasCloseClick) {
          this.overlay.addEventListener('click', (event) => {
            if (event.target === this.overlay) {
              // Find the currently open product-modal and close it
              const openModal = document.querySelector('product-modal[open]');
              if (openModal && typeof openModal.hide === 'function') {
                openModal.hide();
              }
            }
          });

          this.overlay.dataset.hasCloseClick = 'true';
        }
      }

      hide() {
        if (this.dataset.overlay === 'true' && this.overlay) {
          this.overlay.classList.remove('is-visible');
        }

        super.hide();
      }

      show(opener) {
        if (this.dataset.overlay === 'true' && this.overlay) {
          this.overlay.classList.add('is-visible');
        }
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
